import { render, staticRenderFns } from "./assignmentDetail.vue?vue&type=template&id=70bd42b8"
import script from "../../controllers/assignment/assignment-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/assignment/assignment-detail.js?vue&type=script&lang=js&external"
import style0 from "./assignmentDetail.vue?vue&type=style&index=0&id=70bd42b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports